import "./CookiesPolicy.module.css";
import Header from "@/reusable_sections/Header";
import PrivacyOverview from "./sections/PrivacyOverview";
import TheReality from "./sections/TheReality";
import PurposeOfCookies from "./sections/PurposeOfCookies";
import Introduction from "./sections/Introduction";
import TheAdvantage from "./sections/TheAdvantage";
import GetStartedWithItInfrastructure from "./sections/GetStartedWithItInfrastructure";
import Footer from "@/reusable_sections/Footer";
export default function CookiesPolicyPage() {
  return <div>
      <Header />
      <PrivacyOverview />
      <TheReality />
      <PurposeOfCookies />
      <Introduction />
      <TheAdvantage />
      <GetStartedWithItInfrastructure />
      <Footer />
    </div>;
}